var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeProgressLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Time_progress_light"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 55",
    d: "M5.51732 5.51732C3.90184 7.1328 2.89649 9.25845 2.67255 11.5321C2.44862 13.8057 3.01996 16.0867 4.28924 17.9863C5.55851 19.8859 7.44718 21.2866 9.63344 21.9498C11.8197 22.613 14.1683 22.4976 16.279 21.6233C18.3897 20.749 20.132 19.1699 21.209 17.155C22.2859 15.1402 22.631 12.8142 22.1853 10.5735C21.7395 8.33275 20.5307 6.31588 18.7646 4.86652C16.9986 3.41717 14.7846 2.625 12.5 2.625",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 64",
    d: "M12.4998 12.5L7.2915 7.29166",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 93",
    d: "M12.5 2.60416V5.20832",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 95",
    d: "M21.875 12.5L19.7917 12.5",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 94",
    d: "M12.5 19.7917V21.875",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 96",
    d: "M5.2085 12.5L3.12516 12.5",
    stroke: "white",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeProgressLight);
export default __webpack_public_path__ + "static/media/Time_progress_light.c6783466ee66709a61909250f06b8b8e.svg";
export { ForwardRef as ReactComponent };